import { FC, useState } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import ModalDialog from "../../../../ui/ModalDialog";
import LowerElementForm from "./LowerElementForm";

interface CreateLowerElementModalDialogButtonProps {
  steelVersionId?: string;
  installationTypeId?: string;
}

const CreateLowerElementModalDialogButton: FC<CreateLowerElementModalDialogButtonProps> = ({
  installationTypeId,
  steelVersionId,
}: CreateLowerElementModalDialogButtonProps) => {
  const i18n = useI18n();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog onClose={() => setShowNewItemDialog(false)} title={i18n.translation.lowerElements.createNew}>
          <LowerElementForm
            onCancel={() => setShowNewItemDialog(false)}
            onSave={() => {
              setShowNewItemDialog(false);
            }}
            steelVersionId={steelVersionId}
            installationTypeId={installationTypeId}
          />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateLowerElementModalDialogButton;
